function SingleMoviePlaceholder() {
  return (
    <div className="container mb-4" style={{ marginTop: "5rem" }}>
      <div style={{ backgroundColor: "#dae7ed" }} className="p-3">
        <div className="d-flex justify-content-around flex-wrap align-items-center">
          {/* Image placeholder */}
          <div
            className="placeholder-wave"
            style={{ backgroundColor: "azure" }}
          >
            <div
              className="placeholder"
              style={{ width: "19rem", height: "25rem" }}
            ></div>
          </div>
          {/* Movie detail placeholder */}
          <div
            className="p-3 d-flex flex-column"
            style={{ fontSize: "1.2rem", width: "60%" }}
          >
            <div className="card-body">
              <div className="placeholder-glow col-12">
                <div
                  className="placeholder col-12 bg-secondary"
                  style={{ height: "2.2rem" }}
                ></div>
                <hr />
              </div>
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-6"></span>
                <span className="placeholder col-8"></span>
                <span className="placeholder col-8"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-4"></span>
              </p>
              <a
                href="/"
                tabIndex="-1"
                className="btn btn-danger disabled placeholder col-6"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleMoviePlaceholder;
